export default "__VITE_ASSET__aMgV0DoM__"